import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import { ORGANIZATIONS_SEARCH_KEY, SEARCH_DATA_KEY } from 'api/search'
import axios from 'axios'
import { useSyncQueryCache } from './useSyncQueryCache'

const updateOrgTableItem = async ({ PK, SK, tableName, fieldName, newValue }) => {
  console.log('[UpdateItem] called with item: ', { PK, SK, tableName, fieldName, newValue })
  const url = `${baseUrl}/aws/organizations_table/update-item`
  try {
    const response = await axios.put(url, { PK, SK, tableName, fieldName, newValue })
    if (response.status !== 200) throw new Error('Network response was not ok')
    return response.data
  } catch (error) {
    console.error('Failed to update item:', error)
    throw error
  }
}

export const useUpdateOrgTableItem = () => {
  const queryClient = useQueryClient()
  const { syncOrganizationFields, syncDealFields } = useSyncQueryCache()

  const mutation = useMutation({
    mutationFn: updateOrgTableItem,
    onMutate: async variables => {
      const { PK, SK, tableName, fieldName, newValue } = variables

      // Cancel in-flight queries
      await queryClient.cancelQueries({ queryKey: SEARCH_DATA_KEY })

      // Snapshot for rollback
      const previousData = queryClient.getQueryData(SEARCH_DATA_KEY)

      // Optimistically update the appropriate entity type
      if (tableName === 'ORGANIZATIONS_TABLE') {
        if (SK?.startsWith('ORG_')) {
          syncOrganizationFields(queryClient, { PK, SK } as any, [{ fieldName, newValue }])
        } else if (SK?.startsWith('DEAL_')) {
          syncDealFields(queryClient, { PK, SK } as any, [{ fieldName, newValue }])
        }
      }

      return { previousData }
    },
    onSuccess: (_data, variables) => {
      const { tableName, SK } = variables
      console.log('[useUpdateOrgTableItem] Update successful')

      // Invalidate server-side search caches
      if (tableName === 'ORGANIZATIONS_TABLE') {
        if (SK?.startsWith('ORG_')) {
          queryClient.invalidateQueries({ queryKey: ORGANIZATIONS_SEARCH_KEY })
          queryClient.invalidateQueries({ queryKey: ['search', 'organizations'] })
          queryClient.invalidateQueries({ queryKey: ['search', 'mtb'] })
        } else if (SK?.startsWith('DEAL_')) {
          queryClient.invalidateQueries({ queryKey: ['search', 'deals'] })
          queryClient.invalidateQueries({ queryKey: ['search', 'nco'] })
        }
      }
    },
    onError: (error, _variables, context) => {
      // Rollback on error
      if (context?.previousData) {
        queryClient.setQueryData(SEARCH_DATA_KEY, context.previousData)
      }
      console.error('[useUpdateOrgTableItem] Error updating item:', error)
    },
  })
  return mutation
}
